import { dualRoutePath } from './workbenchRoutes';
import { detectMobileOrMiniProgram } from './workbenchLayout';

export { detectMobileOrMiniProgram };
export type SupplierViewMode = 'desktop' | 'h5';

/** 仅按当前运行环境决定界面，不使用本地手动偏好 */
export function resolveSupplierViewMode(): SupplierViewMode {
  return detectMobileOrMiniProgram() ? 'h5' : 'desktop';
}

export function resolveSupplierRoute(): '/supplier-h5' | '/supplier-desktop' {
  return dualRoutePath('supplier', resolveSupplierViewMode() === 'h5') as
    | '/supplier-h5'
    | '/supplier-desktop';
}
